module.exports = __webpack_public_path__ + "static/img/white.7e30b8a.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/CGdesign/src/assets/img/logo/white.png
// module id = 70i6
// module chunks = 1